import React from "react";
import Link from "next/link";
import dynamic from "next/dynamic";
import styles from "./product.module.scss";
import DoubleHeading from "./double-heading";

const ModalVideo = dynamic(() => import("react-modal-video"), {
  ssr: false,
});

export const VideoBox = ({ product, toppersChoice }) => {
  const [isOpen, setIsOpen] = React.useState(true);
  const openModal = () => {
    setIsOpen(!isOpen);
  };
  const getVideoCode = (url) => {
    var regExp =
      /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    var match = url.match(regExp);
    return match && match[7].length == 11 ? match[7] : false;
  };

  return (
    <>
      {toppersChoice && toppersChoice.data && toppersChoice.data.length > 0 ? (
        <>
          <div className="bg-white max-w-5xl mx-auto text-center px-3 sm:px-0 sm:mb-0 margin-bottom-mobile">
            {toppersChoice && toppersChoice.data.length > 0 ? (
              <DoubleHeading
                text={
                  toppersChoice.data[0].content_type &&
                  toppersChoice.data[0].content_type.length > 2
                    ? toppersChoice.data[0].content_type
                    : "TOPPERS CHOICE"
                }
              />
            ) : null}

            {toppersChoice && toppersChoice.data.length > 0 ? (
              <h4 className="font-serif md:text-center sm:text-2xl text-xl mt-6 sm:mt-14">
                {toppersChoice.data[0].title}
              </h4>
            ) : null}

            <div className="flex flex-col lg:flex-row justify-between items-center sm:py-12 py-6 pt-9 sm:pt-0">
              <div className="text-left float-right flex pt-16 md:flex flex-col sm:justify-end items-center">
                {toppersChoice && toppersChoice.data.length > 0 ? (
                  <img
                    src="/img/testimonial-image.png"
                    alt="testimonial"
                    className="w-24 md:w-48"
                  />
                ) : null}
                <h2 className="sm:text-3xl text-xl md:mt-12 max-w-5xl font-serif heading-primary-blue">
                  {toppersChoice && toppersChoice.data.length > 0
                    ? toppersChoice.data[0].name
                    : null}
                </h2>
                <h2 className="text-base font-serif mt-2">
                  {toppersChoice && toppersChoice.data.length > 0
                    ? toppersChoice.data[0].subline
                    : null}
                </h2>
              </div>

              {toppersChoice && toppersChoice.data.length > 0 ? (
                <React.Fragment>
                  <div className="md:mt-20 sm:mt-0">
                    <div className={`${styles.aboutVideoBox}`}>
                      <div className="image">
                        <img
                          src={toppersChoice.data[0].video_thumbnail}
                          alt="image"
                          style={{ width: "100%", height: "100%" }}
                        />
                      </div>

                      <Link href="#play-video">
                        <a
                          onClick={(e) => {
                            e.preventDefault();
                            openModal();
                          }}
                          className={`${styles.videoBtn} popup-youtube`}
                        >
                          <i className="flaticon-play"></i>
                        </a>
                      </Link>

                      <div className={`${styles.shape10}`}>
                        <img src="/images/shape9.png" alt="image" />
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              ) : null}
            </div>
            {toppersChoice &&
              toppersChoice.data &&
              toppersChoice.data.length > 0 && (
                <ModalVideo
                  channel="youtube"
                  isOpen={!isOpen}
                  videoId={getVideoCode(toppersChoice.data[0].video)}
                  onClose={() => setIsOpen(!isOpen)}
                />
              )}
          </div>
        </>
      ) : null}
    </>
  );
};

const VideoBoxMemo = React.memo(VideoBox, (preProps, nextProps) => {
  if (JSON.stringify(preProps.product) !== JSON.stringify(nextProps.product))
    return true;
  return false;
});

export default VideoBox;
